import styled from 'styled-components';
import { Layout, Menu } from 'antd';
const { Header: InHeader, Content: InContent, Footer, Sider } = Layout;

export const sider = {
  overflow: 'auto',
  height: '100vh',
  position: 'fixed',
  left: 0
};

// export const Content = styled(InContent)`
export const Content = styled.div`
  padding: 20px;

  position: absolute;
  inset: 0px;
  width: 100%;
  overflow: auto;

  scrollbar-width: none;
  -ms-overflow-style: none;
  ::-webkit-scrollbar-track {
    -webkit-box-shadow: none !important;
    background-color: transparent;
  }
  ::-webkit-scrollbar {
    width: 3px !important;
    background-color: transparent;
  }
  ::-webkit-scrollbar-thumb {
    background-color: transparent;
  }

  & > div:first-child {
    position: relative;
    min-height: 100%;
  }
`;

export const ContentLayout = styled(Layout)`
  position: relative;
  background: transparent !important;
  min-height: 100%;
  overflow: auto;

  & main {
    margin: 0px !important;
  }

  & main > div:first-child {
    min-height: 100%;
  }

  & .ant-layout {
    background: transparent !important;
  }
`;

export const Header = styled(InHeader)``;

export const CaptainPaymentLayout = styled(Layout)`
  margin: 0;
  height: 100%;
`;
